import { apiCall } from './generated/gqlClient';

export const getProviderAnalyticsApiRequest = async () => {
  const query = `
    query getProviderAnalytics {
      getProviderAnalytics {
        users {
          id
          created
        }
        orders {
          id
          productId
          reservationId
          subscriptionId
          userMembershipId
          userPlanId
          date
          price
          paidWithUserMembershipId
        }
        reservations {
          id
          created
        }
        subscriptions {
          id
          created
        }
      }
    }
  `;

  return apiCall({ query });
};
